import React from "react";
import { Box } from "@mui/material";
import { NavVault } from "./NavVault";
import SideVault from "./SideVault";
import VaultOpen from "./VaultOpen";

const UNLOCK_SECONDS = 110;

export const VaultContent = ({ isPreviewMode }: { isPreviewMode?: boolean }) => {
  const [unlocked, setUnlocked] = React.useState(isPreviewMode);
  const [remainingSeconds, setRemainingSeconds] = React.useState(0);

  const intervalRef = React.useRef<number | null>(null);

  const clearTick = () => {
    if (intervalRef.current) window.clearInterval(intervalRef.current);
    intervalRef.current = null;
  };

  const lockNow = React.useCallback(() => {
    clearTick();
    setUnlocked(false);
    setRemainingSeconds(0);
  }, []);

  const unlockNow = React.useCallback(() => {
    clearTick();

    setUnlocked(true);
    setRemainingSeconds(UNLOCK_SECONDS);

    intervalRef.current = window.setInterval(() => {
      setRemainingSeconds((prev) => {
        const next = Math.max(0, prev - 1);
        if (next === 0) {
          clearTick();
          setUnlocked(false);
        }
        return next;
      });
    }, 1000);
  }, []);

  React.useEffect(() => {
    if (isPreviewMode) {
      unlockNow();
    }
    return () => clearTick();
  }, [isPreviewMode, unlockNow]);

  return (
    <>
      <NavVault locked={unlocked} onLock={lockNow} />

      <Box sx={{ width: "100%", height: "100%", display: "flex" }}>
        <SideVault unlocked={unlocked} companyId={1} remainingSeconds={remainingSeconds} isPreviewMode={isPreviewMode} />

        <VaultOpen
          unlocked={unlocked}
          onUnlock={unlockNow}
          onLock={lockNow}
          remainingSeconds={remainingSeconds}
        />
      </Box>
    </>
  );
};

export default VaultContent;
